import { render, staticRenderFns } from "./UIFilterTemplate.vue?vue&type=template&id=44e0e909&"
import script from "./UIFilterTemplate.vue?vue&type=script&lang=js&"
export * from "./UIFilterTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports